module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/wob-boardroom-simulation.json
// module id = 1536
// module chunks = 129175002033977